import Timing from '../Timing/Timing';

export default class Scroll {

	constructor() {
		this.animationFrame = null;

		window.addEventListener('mousewheel',     e => this.stop());
		window.addEventListener('DOMMouseScroll', e => this.stop());
		window.addEventListener('touchmove',      e => this.stop());
		window.addEventListener('touchstart',     e => this.stop());
	}

	to(el, duration, offset) {
		this.el             = (typeof el === 'string') ? document.querySelector(el) : el;
		this.duration       = duration;
		this.offset         = (typeof offset === 'number') ? offset : 0;
		this.offset        -= (document.body.classList.contains('admin-bar')) ? 32 : 0;
		this.offset        -= (document.body.classList.contains('admin-bar') && window.innerWidth <= 782) ? 14 : 0;
		this.timing         = new Timing('easeInOutQuad', this.duration);
		this.start          = window.pageYOffset;
		this.marginTop      = parseInt(window.getComputedStyle(this.el, null).marginTop.replace('px', ''));
		this.diff           = Math.round(this.el.getBoundingClientRect().top - this.marginTop) + this.offset;
		this.end            = this.start + this.diff;

		this.stop();

		if (this.start != this.end) {
			this.animationFrame = requestAnimationFrame(timestamp => this.scroll(timestamp));
		}
	}

	top(pos, duration) {
		this.pos      = pos;
		this.duration = duration;
		this.timing   = new Timing('easeInOutQuad', this.duration);
		this.start    = window.pageYOffset;
		this.diff     = this.pos - this.start;
		this.end      = this.pos;

		this.stop();

		if (this.start != this.end) {
			this.animationFrame = requestAnimationFrame(timestamp => this.scroll(timestamp));
		}
	}

	stop() {
		cancelAnimationFrame(this.animationFrame);
	}

	scroll(timestamp) {
		this.timing.increase(timestamp);
		let pos = this.start + this.diff * this.timing.t;

		window.scrollTo(0, pos);

		if (window.pageYOffset != this.end) {
			this.animationFrame = requestAnimationFrame(timestamp => this.scroll(timestamp));
		}
	}

}

if (window.vb && !vb.scroll) {
	vb.scroll = new Scroll();
}
